const AUTH_COOKIE_NAME = 'technyc_auth_token';
export const AUTH_COOKIE_MAX_AGE_SECONDS = 48 * 60 * 60; // 48 hours

function isBrowser(): boolean {
  return typeof document !== 'undefined';
}

function buildCookieAttributes(maxAgeSeconds: number): string {
  return `Max-Age=${maxAgeSeconds}; Expires=${new Date(Date.now() + maxAgeSeconds * 1000).toUTCString()}; Path=/; Secure; SameSite=Lax`;
}

function decodeJwtPayload(token: string): { exp?: number } | null {
  if (!isBrowser()) return null;
  const parts = token.split('.');
  if (parts.length < 2) return null;
  try {
    const payload = parts[1]
      .replace(/-/g, '+')
      .replace(/_/g, '/');
    const paddedPayload = payload.padEnd(payload.length + ((4 - (payload.length % 4)) % 4), '=');
    const decoded = atob(paddedPayload);
    return JSON.parse(decoded);
  } catch {
    return null;
  }
}

export function setAuthTokenCookie(token: string, maxAgeSeconds: number = AUTH_COOKIE_MAX_AGE_SECONDS): void {
  if (!isBrowser()) return;
  const attributes = buildCookieAttributes(maxAgeSeconds);
  document.cookie = `${AUTH_COOKIE_NAME}=${encodeURIComponent(token)}; ${attributes}`;
}

export function getAuthTokenCookie(): string | undefined {
  if (!isBrowser()) return undefined;
  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const [name, ...valueParts] = cookie.split('=');
    if (!name) continue;
    if (name.trim() === AUTH_COOKIE_NAME) {
      return decodeURIComponent(valueParts.join('='));
    }
  }
  return undefined;
}

export function hasValidAuthToken(): boolean {
  if (!isBrowser()) return false;
  const token = getAuthTokenCookie();
  if (!token) return false;
  const payload = decodeJwtPayload(token);
  if (!payload?.exp) return false;
  const expiresAtMs = payload.exp * 1000;
  return Date.now() < expiresAtMs;
}

export function clearAuthTokenCookie(): void {
  if (!isBrowser()) return;
  document.cookie = `${AUTH_COOKIE_NAME}=; Max-Age=0; Expires=${new Date(0).toUTCString()}; Path=/; Secure; SameSite=Lax`;
}
